import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { dollarsToCents } from 'src/shared/util/money';

/**
 * Validates that a currency-masked price is either unset or at least
 * `minimumCents`. Mirrors backend params that take `0` (no price) or a real
 * amount, so a host who types "$0.50" is stopped inline instead of by a 400.
 *
 * Blank and $0.00 pass: both are sent as "no price".
 */
export function validateMinimumPrice(minimumCents: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const cents = dollarsToCents(control.value);
    if (cents === null || cents >= minimumCents) {
      return null;
    }
    return { belowMinimumPrice: { minimumCents, actualCents: cents } };
  };
}
